import Dropdown from "@/components/common/Dropdown"
import { RefreshIcon } from "@/components/icons"
import { FiltersProps } from "@/data/types"
import { formatNumber, getPropertyTypeOptions, getStatusOptions } from "@/utils/helpers"
import clsx from "clsx"


export default function DesktopFilters({ translations, selectedPropertyType, availablePropertyTypes, 
  priceFrom, priceTo, selectedStatus, availableStatuses, handlePropertyTypeChange, handlePriceFromChange, handlePriceToChange,
  handleStatusChange, onClearFilters, disabled }: FiltersProps) {

  const propertyTypeOptionsFormatted = getPropertyTypeOptions(availablePropertyTypes, translations)
  const statusOptionsFormatted = getStatusOptions(availableStatuses, translations)

  return (
    <div className="hidden lg:flex flex-row justify-between gap-[20px] flex-wrap">
      <div className="flex flex-row gap-[16px] items-center">
        <button
          onClick={onClearFilters} disabled={disabled}
          className={clsx(`group relative flex items-center justify-center p-3 rounded-full border border-[#302E2D]/20 `, 
            !disabled && 'transition-all duration-300 hover:border-[#1B1D2B]/40 active:scale-95', disabled ? "cursor-auto" : 'cursor-pointer' 
          )}
        >
          <RefreshIcon width={18} height={18} color="#6b6b6b"
            className={clsx(!disabled && "transition-transform duration-500 ease-in-out group-hover:rotate-[-360deg]")}
          />
        </button>


        <div className="border border-[#302E2D]/20 px-[15px] py-[7px] rounded-[10px] text-[#1B1D2B] flex flex-row gap-[15px]">
          {/* <Dropdown
            options={cityOptionsFormatted}
            value={selectedCity}
            onChange={(value) => handleCityChange(value as string)}
            label={translations?.cityLabel as string}
            className="min-w-[160px] max-w-[258px]"
            isDisabled={disabled}
          />

          <div className="w-px bg-[#302E2D]/20 my-1" /> */}

          <Dropdown
            options={propertyTypeOptionsFormatted}
            value={selectedPropertyType}
            onChange={(value) => handlePropertyTypeChange(value as string)}
            label={translations?.propertyTypeLabel as string}
            className="min-w-[160px] max-w-[258px]"
            isDisabled={disabled}
          />
        </div>

        <div className="border border-[#302E2D]/20 px-[15px] py-[7px] rounded-[10px] text-[#1B1D2B] text-[14px] flex flex-row gap-[18px] h-full">
          <div className="relative w-[135px] flex">
            <input
              type="text"
              placeholder={translations?.min as string}
              className="w-full border-none focus:outline-none focus:ring-0 pr-[40px] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none [&-moz-appearance:textfield]"
              value={formatNumber(priceFrom)}
              onChange={(e) => handlePriceFromChange(e.target.value.replace(/\s/g, ""))}
              disabled={disabled}
            />
            <span className="absolute right-0 top-1/2 transform -translate-y-1/2 text-[#C3C3C3] text-[13px] leading-[27px] font-normal">
              AED
            </span>
          </div>

          <div className="w-px bg-[#302E2D]/20 my-1" />

          <div className="relative w-[135px] flex">
            <input
              type="text"
              placeholder={translations?.max as string}
              className="w-full border-none focus:outline-none focus:ring-0 pr-[40px] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none [&-moz-appearance:textfield]"
              value={formatNumber(priceTo)}
              onChange={(e) => handlePriceToChange(e.target.value.replace(/\s/g, ""))}
              disabled={disabled}
            />
            <span className="absolute right-0 top-1/2 transform -translate-y-1/2 text-[#C3C3C3] text-[13px] leading-[27px] font-normal">
              AED
            </span>
          </div>
        </div>
      </div>

      <div className="border border-[#302E2D]/20 w-fit px-[15px] py-[7px] rounded-[10px] text-[#1B1D2B] text-[14px] flex flex-row gap-[18px]">
        <Dropdown
          options={statusOptionsFormatted}
          value={selectedStatus}
          onChange={(value) => handleStatusChange(value as string)}
          label={translations?.statusLabel as string}
          className="min-w-[160px] max-w-[258px]"
          isDisabled={disabled}
        />
      </div>
    </div>
  )
}